<script>
import FAQCollapse from "@/components/FAQCollapse";
import ErrorMessage from "@/components/ErrorMessage";
import Loader from "@/components/Loader";
import { usePagesStore } from "../stores/pages";

// Since FAQ and Legislative are basically the same page,
// we make a single component which takes a page type as prop.
export default {
  setup() {
    const pageStore = usePagesStore();
    return {
      pageStore,
    }
  },
  components: {
    FAQCollapse,
    ErrorMessage,
    Loader,
  },
  props: {
    pageType: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      errors: [],
      loading: true,
    };
  },
  computed: {
    currentPages() {
      const pages = this.pageStore[this.pageType];
      return (
        !!pages &&
        pages.length > 0 &&
        pages.sort(({ order: orderA }, { order: orderB }) => orderA - orderB)
      );
    },
  },
  async mounted() {
    if (!this.currentPages) {
      const error = await this.pageStore.refresh();
      if (error) {
        if (error.status == 404) {
          this.errors.push({
            id: Date.now(),
            message: "Bad Request",
          })
        } else {
          this.errors.push({
            id: Date.now(),
            message: error.data.message,
          });
        }
      }
    }
    this.loading = false;
  },
  methods: {
    closeMessage(id) {
      Object.keys(this.errors).forEach((key) => {
        if (id === this.errors[key].id) {
          this.errors.splice(key, 1);
        }
      });
    },
  },
};
</script>

<template>
  <div class="mt-6 px-8 w-full">
    <h1 class="mb-6 text-3xl font-light text-gray-700">
      {{ title }}
    </h1>
    <hr class="my-8 border-t border-solid border-gray-200" />
    <br />
    <ErrorMessage v-for="msg in errors" :key="msg.id" :value="msg" @input="closeMessage" />
    <div v-if="loading" class="text-center flex flex-col">
      <Loader class="block mx-auto mb-2" />
      <span class="text-center">{{ $t("components.pages_display") }}</span>
    </div>
    <FAQCollapse v-for="page in currentPages" :key="page.id" :page="page" />
  </div>
</template>
